module.exports = __webpack_public_path__ + "static/media/jirou-kyouka-icon.033d9896.png";